import { h } from "@stencil/core";
const getSubLevelEntitiesATTs = (result, level) => {
    level.forEach(entityItem => {
        const entityItemLevel = entityItem.Level;
        if (entityItem.Type === "LEVEL") {
            /* Following level entities with DataType */
            result[entityItem.DataType] = entityItemLevel.map(subEntityItem => subEntityItem.Name);
            getSubLevelEntitiesATTs(result, entityItemLevel);
        }
    });
};
const updateToEntityATTs = (dm) => {
    if (!dm) {
        return {};
    }
    const result = {};
    dm.Entities.forEach((entity) => {
        const entityLevel = entity.Level;
        /* First level entities with name */
        result[entity.Name] = entityLevel.map(entityItem => entityItem.Name);
        if (entityLevel) {
            getSubLevelEntitiesATTs(result, entityLevel);
        }
    });
    return result;
};
export class NextDataModeling {
    constructor() {
        this.addingModeCommonClass = undefined;
        this.captions = {
            ATT: "Attribute",
            ENTITY: "Entity",
            LEVEL: "Collection",
            adding: "Adding...",
            addNewEntity: "Add new entity",
            addNewField: "Add new field",
            cancel: "Cancel",
            collection: "Collection",
            confirm: "Confirm",
            delete: "Delete",
            deleteMode: "Confirm delete?",
            deleting: "Deleting...",
            edit: "Edit",
            editing: "Saving...",
            newEntity: "New Entity",
            newField: "New Field"
        };
        this.commonClass = undefined;
        this.createGxCollectionCallback = undefined;
        this.cssClass = undefined;
        this.dataModel = undefined;
        this.dataModelToEdit = undefined;
        this.disabled = false;
        this.entityAddingModeClass = undefined;
        this.entityClass = undefined;
        this.errorTexts = {
            Empty: "Field is empty.",
            AlreadyDefined1: "Field ",
            AlreadyDefinedEntity1: "Entity ",
            AlreadyDefined2: " already exists."
        };
        this.fieldAddingModeClass = undefined;
        this.fieldClass = undefined;
        this.fieldContainerClass = undefined;
        this.fieldCommonClass = undefined;
        this.hideLoading = null;
        this.maxAtts = 3;
        this.readonly = false;
        this.subFieldClass = undefined;
        this.subFieldAddingModeClass = undefined;
        this.subFieldContainerClass = undefined;
    }
    entityNameToATTs;
    entities = [];
    editedControl = null;
    entityWasAdded = "none";
    handleDataModelChange(newDataModel) {
        this.entityNameToATTs = updateToEntityATTs(newDataModel);
        this.entities = Object.keys(this.entityNameToATTs);
    }
    handleHideLoadingChange() {
        this.editedControl.hideWaitingMode();
        if (this.entityWasAdded === "adding") {
            this.entityWasAdded = "finished";
            this.processEntityAdding();
        }
    }
    /**
     * Emitted when a new field is added or edited.
     */
    fieldAdded;
    /**
     * Emitted when a new field is removed.
     */
    fieldRemoved;
    addField = (collection) => (event) => {
        this.addEntityItem(collection, event.detail);
        this.updateReferences(event, true);
    };
    addEntityItem(collection, item) {
        const newItem = {
            Name: item.name,
            Type: item.type,
            DataType: ""
        };
        collection.push(newItem);
    }
    deleteField = (collection, index) => (event) => {
        collection.remove(index + 1);
        this.updateReferences(event);
    };
    editField = (entityItem) => (event) => {
        entityItem.Name = event.detail.name;
        entityItem.Type = event.detail.type;
        entityItem.DataType = ""; // Remove DataType
        this.updateReferences(event, true);
    };
    addEntity = (collection) => (event) => {
        this.entityWasAdded = "adding";
        const newItem = {
            Name: event.detail.name,
            Level: this.createGxCollectionCallback()
        };
        collection.push(newItem);
        this.addEntityItem(newItem.Level, event.detail.level[0]);
        this.updateReferences(event, true);
    };
    editEntity = (entityItem) => (event) => {
        entityItem.Name = event.detail.name;
        this.updateReferences(event, true);
    };
    updateReferences(event, fieldAdded = false) {
        event.stopPropagation();
        this.editedControl = event.target;
        if (fieldAdded) {
            this.fieldAdded.emit();
        }
        else {
            this.fieldRemoved.emit();
        }
        this.processEntityAdding();
    }
    processEntityAdding() {
        if (!this.editedControl || this.entityWasAdded === "none") {
            return;
        }
        const entityClassList = this.editedControl.classList;
        const firstItemContainerClassList = this.editedControl.firstElementChild.classList;
        const firstItemClassList = this.editedControl.firstElementChild.firstElementChild.classList;
        if (this.entityWasAdded === "adding") {
            entityClassList.remove(this.addingModeCommonClass, this.entityAddingModeClass);
            entityClassList.add(this.entityClass, this.commonClass);
            firstItemContainerClassList.add(this.fieldContainerClass);
            firstItemClassList.remove(this.addingModeCommonClass, ...this.fieldAddingModeClass.split(" "));
            firstItemClassList.add(this.fieldClass, this.fieldCommonClass, this.commonClass);
            return;
        }
        if (this.entityWasAdded === "finished") {
            entityClassList.remove(this.entityClass);
            entityClassList.add(this.addingModeCommonClass, this.entityAddingModeClass);
            firstItemContainerClassList.remove(this.fieldContainerClass);
            firstItemClassList.remove(this.fieldClass);
            firstItemClassList.add(this.addingModeCommonClass, ...this.fieldAddingModeClass.split(" "));
            this.entityWasAdded = "none";
            return;
        }
    }
    componentWillLoad() {
        this.handleDataModelChange(this.dataModel);
    }
    render() {
        return (h("ch-next-data-modeling", { class: this.cssClass }, this.dataModel != null &&
            this.dataModel.Entities != null &&
            this.dataModel.Entities.map((entity, i) => (h("ch-next-data-modeling-item", { key: entity.Name, captions: this.captions, class: this.entityClass + " " + this.commonClass, disabled: this.disabled, errorTexts: this.errorTexts, fieldNames: this.entities, name: entity.Name, level: 0, readonly: this.readonly, onDeleteField: !this.readonly
                    ? this.deleteField(this.dataModelToEdit?.Entities, i)
                    : null, onEditField: !this.readonly
                    ? this.editEntity(this.dataModelToEdit?.Entities[i])
                    : null }, h("ch-next-data-modeling", { class: this.fieldContainerClass }, entity.Level.map((field, j) => (h("ch-next-data-modeling-item", { key: field.Name, captions: this.captions, class: this.fieldClass +
                    " " +
                    this.fieldCommonClass +
                    " " +
                    this.commonClass, dataType: field.DataType, disabled: this.disabled, entityNameToATTs: this.entityNameToATTs, errorTexts: this.errorTexts, fieldNames: this.entityNameToATTs[entity.Name], maxAtts: this.maxAtts, name: field.Name, readonly: this.readonly, type: field.Type, onDeleteField: !this.readonly
                    ? this.deleteField(this.dataModelToEdit?.Entities[i].Level, j)
                    : null, onEditField: !this.readonly
                    ? this.editField(this.dataModelToEdit?.Entities[i].Level[j])
                    : null }, field.Level != null && field.Level.length > 0 && (h("ch-next-data-modeling", { class: this.subFieldContainerClass }, field.Level.map((subField, k) => (h("ch-next-data-modeling-item", { key: subField.Name, captions: this.captions, class: this.subFieldClass +
                    " " +
                    this.fieldCommonClass +
                    " " +
                    this.commonClass, dataType: subField.DataType, disabled: this.disabled, entityNameToATTs: this.entityNameToATTs, errorTexts: this.errorTexts, fieldNames: this.entityNameToATTs[field.DataType], level: 2, maxAtts: this.maxAtts, name: subField.Name, readonly: this.readonly, type: subField.Type, onDeleteField: !this.readonly
                    ? this.deleteField(this.dataModelToEdit?.Entities[i].Level[j]
                        .Level, k)
                    : null, onEditField: !this.readonly
                    ? this.editField(this.dataModelToEdit?.Entities[i].Level[j]
                        .Level[k])
                    : null }))), !this.readonly && (h("ch-next-data-modeling-item", { key: "-1", captions: this.captions, class: this.subFieldAddingModeClass +
                    " " +
                    this.fieldCommonClass +
                    " " +
                    this.addingModeCommonClass +
                    " " +
                    this.commonClass, disabled: this.disabled, errorTexts: this.errorTexts, fieldNames: this.entityNameToATTs[field.DataType], level: 2, mode: "add", type: "ATT", onNewField: this.addField(this.dataModelToEdit?.Entities[i].Level[j].Level) }))))))), !this.readonly && (h("ch-next-data-modeling-item", { key: "-1", captions: this.captions, class: this.fieldAddingModeClass +
                    " " +
                    this.fieldCommonClass +
                    " " +
                    this.addingModeCommonClass +
                    " " +
                    this.commonClass, disabled: this.disabled, errorTexts: this.errorTexts, fieldNames: this.entityNameToATTs[entity.Name], mode: "add", type: "ATT", onNewField: this.addField(this.dataModelToEdit?.Entities[i].Level) })))))), this.dataModel?.Entities && !this.readonly && (h("ch-next-data-modeling-item", { key: "-1", captions: this.captions, class: this.entityAddingModeClass +
                " " +
                this.addingModeCommonClass +
                " " +
                this.commonClass, disabled: this.disabled, errorTexts: this.errorTexts, fieldNames: this.entities, level: 0, mode: "add", onNewEntity: this.addEntity(this.dataModelToEdit?.Entities) }, h("ch-next-data-modeling", null, h("ch-next-data-modeling-item", { actionsVisible: false, captions: this.captions, class: this.fieldAddingModeClass +
                " " +
                this.fieldCommonClass +
                " " +
                this.addingModeCommonClass +
                " " +
                this.commonClass, disabled: this.disabled, errorTexts: this.errorTexts, mode: "add", showNewFieldBtn: false, type: "ATT" }))))));
    }
    static get is() { return "ch-next-data-modeling-render"; }
    static get originalStyleUrls() {
        return {
            "$": ["next-data-modeling-render.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["next-data-modeling-render.css"]
        };
    }
    static get properties() {
        return {
            "addingModeCommonClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class when\nadding mode is enabled."
                },
                "attribute": "adding-mode-common-class",
                "reflect": false
            },
            "captions": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "DataModelItemLabels",
                    "resolved": "{ collection: string; confirm: string; cancel: string; ATT: string; ENTITY: string; LEVEL: string; adding: string; addNewEntity: string; addNewField: string; edit: string; editing: string; delete: string; deleting: string; deleteMode: string; newEntity: string; newField: string; }",
                    "references": {
                        "DataModelItemLabels": {
                            "location": "import",
                            "path": "../data-modeling-item/next-data-modeling-item",
                            "id": "src/components/next/data-modeling-item/next-data-modeling-item.tsx::DataModelItemLabels"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The labels used in the buttons of the items. Important for accessibility."
                },
                "defaultValue": "{\n    ATT: \"Attribute\",\n    ENTITY: \"Entity\",\n    LEVEL: \"Collection\",\n    adding: \"Adding...\",\n    addNewEntity: \"Add new entity\",\n    addNewField: \"Add new field\",\n    cancel: \"Cancel\",\n    collection: \"Collection\",\n    confirm: \"Confirm\",\n    delete: \"Delete\",\n    deleteMode: \"Confirm delete?\",\n    deleting: \"Deleting...\",\n    edit: \"Edit\",\n    editing: \"Saving...\",\n    newEntity: \"New Entity\",\n    newField: \"New Field\"\n  }"
            },
            "commonClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class."
                },
                "attribute": "common-class",
                "reflect": false
            },
            "createGxCollectionCallback": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "() => EntityItem[]",
                    "resolved": "() => EntityItem[]",
                    "references": {
                        "EntityItem": {
                            "location": "import",
                            "path": "../data-modeling/data-model",
                            "id": "src/components/next/data-modeling/data-model.ts::EntityItem"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This callback is used to created a new SDT GxCollectionField based on the\nEntityItem type."
                }
            },
            "cssClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling` element class."
                },
                "attribute": "css-class",
                "reflect": false
            },
            "dataModel": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "DataModel",
                    "resolved": "{ Entities: Entity[]; }",
                    "references": {
                        "DataModel": {
                            "location": "import",
                            "path": "../data-modeling/data-model",
                            "id": "src/components/next/data-modeling/data-model.ts::DataModel"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property represents the UI model that is currently rendered."
                }
            },
            "dataModelToEdit": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "DataModel",
                    "resolved": "{ Entities: Entity[]; }",
                    "references": {
                        "DataModel": {
                            "location": "import",
                            "path": "../data-modeling/data-model",
                            "id": "src/components/next/data-modeling/data-model.ts::DataModel"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property represents a copy of the UI model that is currently rendered.\nUseful for making changes that may or may not be accepted by the server."
                }
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This attribute lets you specify if the element is disabled.\nIf disabled, it will not fire any user interaction related event."
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "entityAddingModeClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class with\n`level === \"0\"` and `mode === \"add\"`."
                },
                "attribute": "entity-adding-mode-class",
                "reflect": false
            },
            "entityClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class with\n`level === \"0\"` and `mode !== \"add\"`."
                },
                "attribute": "entity-class",
                "reflect": false
            },
            "errorTexts": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "{ [key in ErrorText]: string }",
                    "resolved": "{ Empty: string; AlreadyDefined1: string; AlreadyDefinedEntity1: string; AlreadyDefined2: string; }",
                    "references": {
                        "ErrorText": {
                            "location": "import",
                            "path": "../data-modeling-item/next-data-modeling-item",
                            "id": "src/components/next/data-modeling-item/next-data-modeling-item.tsx::ErrorText"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The error texts used for the new field input."
                },
                "defaultValue": "{\n    Empty: \"Field is empty.\",\n    AlreadyDefined1: \"Field \",\n    AlreadyDefinedEntity1: \"Entity \",\n    AlreadyDefined2: \" already exists.\"\n  }"
            },
            "fieldAddingModeClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class with\n`level === \"0\" | \"1\"` and `mode === \"add\"`."
                },
                "attribute": "field-adding-mode-class",
                "reflect": false
            },
            "fieldClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class with\n`level === \"1\"` and `mode !== \"add\"`."
                },
                "attribute": "field-class",
                "reflect": false
            },
            "fieldContainerClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling` element class with\n`level === \"1\"`."
                },
                "attribute": "field-container-class",
                "reflect": false
            },
            "fieldCommonClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class with\n(`level === \"0\"` and `mode !== \"add\"`) or `level === \"1\" | \"2\"`."
                },
                "attribute": "field-common-class",
                "reflect": false
            },
            "hideLoading": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This property is a WA due to Angular's bug not letting execute UC 2.0\nmethods on different layouts."
                },
                "attribute": "hide-loading",
                "reflect": false,
                "defaultValue": "null"
            },
            "maxAtts": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Determine the maximum amount of ATTs displayed per entity."
                },
                "attribute": "max-atts",
                "reflect": false,
                "defaultValue": "3"
            },
            "readonly": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "This attribute indicates that the user cannot modify the value of the control.\nSame as [readonly](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly)\nattribute for `input` elements."
                },
                "attribute": "readonly",
                "reflect": false,
                "defaultValue": "false"
            },
            "subFieldClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class with\n`level = \"2\"` and `mode !== \"add\"`."
                },
                "attribute": "sub-field-class",
                "reflect": false
            },
            "subFieldAddingModeClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling-item` element class with\n`level = \"2\"` and `mode === \"add\"`."
                },
                "attribute": "sub-field-adding-mode-class",
                "reflect": false
            },
            "subFieldContainerClass": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A CSS class to set as the `ch-next-data-modeling` element class with\n`level === \"2\"`."
                },
                "attribute": "sub-field-container-class",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "fieldAdded",
                "name": "fieldAdded",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when a new field is added or edited."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "fieldRemoved",
                "name": "fieldRemoved",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when a new field is removed."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get watchers() {
        return [{
                "propName": "dataModel",
                "methodName": "handleDataModelChange"
            }, {
                "propName": "hideLoading",
                "methodName": "handleHideLoadingChange"
            }];
    }
}
//# sourceMappingURL=next-data-modeling-render.js.map
